import { IonRow, IonCol } from '@ionic/react';
import React from 'react';
import CompetitionsMenu from '../../components/ExchCompetitionsMenu/ExchCompetitionsMenu';
import EventsTable from '../../components/ExchEventsTable/ExchEventsTable';
import './ExchangeSportsHomeView.scss';
import { RootState } from '../../models/RootState';
import { connect } from 'react-redux';
import { SelectedObj } from '../../models/ExchangeSportsState';
import ExchRaceEventsTable from '../../components/ExchEventsTable/ExchRaceEventsTable';

type StoreProps = {
  loggedIn: boolean;
  selectedEventType: SelectedObj;
};

const ExchSportsHome: React.FC<StoreProps> = (props) => {
  const { loggedIn, selectedEventType } = props;
  return (
    <div>
      <IonRow className="sports-home-view">
        <IonCol className="competitions-menu-section">
          <div className="sticky-col">
            <CompetitionsMenu />
          </div>
        </IonCol>
        <IonCol className="events-table-section">
          {!['77', '4339'].includes(selectedEventType.id) ? (
            <EventsTable loggedIn={loggedIn} />
          ) : (
            <ExchRaceEventsTable loggedIn={loggedIn} />
          )}
        </IonCol>
      </IonRow>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    selectedEventType: state.exchangeSports.selectedEventType,
  };
};

export default connect(mapStateToProps)(ExchSportsHome);
